"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core/");
var _Text = _interopRequireDefault(require("../Text"));
var _StagePanel = _interopRequireDefault(require("./StagePanel"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      fontSize: theme.typography.pxToRem(16)
    },
    stageWrapper: {
      marginTop: '6px'
    },
    h2: {
      marginBottom: '5px',
      marginTop: '0 !important'
    },
    indicator: {
      position: 'relative',
      height: '13px',
      margin: '8px 0'
    }
  };
});
var VerticalWorkflow = function VerticalWorkflow(_ref) {
  var _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? 'Workflow Vertical' : _ref$heading,
    itemText = _ref.itemText,
    singleExpansion = _ref.singleExpansion,
    expandedItems = _ref.expandedItems,
    stages = _ref.stages,
    ariaLabel = _ref.ariaLabel,
    anchorId = _ref.anchorId;
  var classes = useStyles();
  var _React$useState = _react.default.useState(function () {
      var expandedArray = expandedItems;
      if (singleExpansion) {
        expandedArray = [expandedItems[0]];
      }
      return expandedArray;
    }),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    expanded = _React$useState2[0],
    setExpanded = _React$useState2[1];
  var handleChange = function handleChange(panel) {
    return function (event, isExpanded) {
      event.stopPropagation();
      if (isExpanded && expanded.indexOf(panel) < 0) {
        var newState = singleExpansion ? [] : expanded;
        setExpanded(newState.concat(panel));
      }
      if (!isExpanded && expanded.indexOf(panel) > -1) {
        setExpanded(expanded.filter(function (el) {
          return el !== panel;
        }));
      }
    };
  };
  return __jsx(_core.Grid, {
    container: true,
    id: anchorId,
    className: "aem-ms-cmp aem-ms-vertical-workflow",
    "aria-label": ariaLabel
  }, __jsx(_core.Grid, {
    className: classes.wrapper,
    item: true,
    xs: 12,
    md: 12
  }, __jsx(_core.Grid, {
    item: true,
    xs: 12,
    md: 9
  }, heading && __jsx("h2", {
    className: classes.h2,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), itemText && itemText.text && __jsx(_Text.default, itemText)), stages && stages.length > 0 && __jsx(_core.Grid, {
    className: classes.stageWrapper,
    container: true,
    spacing: 0
  }, stages.map(function (stage, panelIndex) {
    return __jsx(_StagePanel.default, {
      key: panelIndex,
      first: panelIndex === 0,
      last: panelIndex === stages.length - 1,
      stage: stage,
      expanded: expanded.indexOf(panelIndex) > -1,
      disabled: singleExpansion && expanded.indexOf(panelIndex) > -1,
      onChange: handleChange(panelIndex)
    });
  }))));
};
var VerticalWFEditConfig = {
  emptyLabel: 'Vertical Workflow',
  isEmpty: function isEmpty(props) {
    if (props.stages && props.stages.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/workflows/vertical')(VerticalWorkflow, VerticalWFEditConfig);
exports.default = _default;